import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/mobile-controls.css";
import "@/app-shell-layout-fixes.css";
import "@/casting-mobile.css";
import "@/mobile-platform-hardening.css";
import "@/mobile-profile-polish.css";
import "@/dark-mode-professional.css";
import "@/mobile-dialog-hardening.css";
import "@/utils/axios";  // Setup axios interceptors for auth
import App from "@/App";
import CookieConsentBanner from "@/components/CookieConsentBanner";
import { registerServiceWorker } from "@/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    <CookieConsentBanner />
  </React.StrictMode>,
);

// Register the PWA service worker for push notifications. No-op on
// browsers without serviceWorker support.
registerServiceWorker();